//Types
import {
  BUSCAR_TDOCS,
  MODIFICAR_FILTROS,
  CARGANDO_CONTROL,
  ACTUALIZAR_TDOC,
  AGREGAR_TDOC,
  ELIMINAR_TDOC,
  APLICAR_FILTROS,
  INICIALIZAR_FILTROS,
  MODIFICAR_FILTROS_ESTADOS,
  MODIFICAR_FILTROS_RANGO,
  INICIAR_FILTROS,
  SET_INICIAR_FILTROS_IS_LOADING,
  SET_ACTIVE_WORKSPACE,
} from './controlActions';

const controlReducer = (state, action) => {
  switch (action.type) {
    case INICIAR_FILTROS: {
      return {
        ...state,
        filtrosEstado: action.payload.filtrosEstado,
        listTDoc: action.payload.tDocs,
        listTDocBase: action.payload.tDocs,
        filtrosEstadoPredeterminado: action.payload.filtrosEstado,
        cargando: false,
      };
    }

    case MODIFICAR_FILTROS_RANGO: {
      return {
        ...state,
        filtrosRango: action.payload.filtrosRango,
        listTDoc: action.payload.listaComprobantes,
        cargando: false,
      };
    }

    case MODIFICAR_FILTROS_ESTADOS: {
      return {
        ...state,
        filtrosEstado: action.payload,
        cargando: false,
      };
    }

    case AGREGAR_TDOC: {
      return {
        ...state,
        listTDoc:
          state.listTDoc !== null ? [action.payload, ...state.listTDoc] : [],
          listTDocBase: (state.listTDocBase !== null) ? [action.payload , ...state.listTDocBase ] : []
      };
    }

    case ACTUALIZAR_TDOC: {
      return {
        ...state,
        listTDoc: state.listTDoc.map(t =>
          t._id === action.payload._id ? action.payload : t
        ),
        listTDocBase: (state.listTDocBase || []).map((t) => t._id === action.payload._id ? action.payload : t)
      };
    }

    case SET_INICIAR_FILTROS_IS_LOADING: {
      return {
        ...state,
        iniciarFiltrosIsLoading: action.payload,
      };
    }

    case SET_ACTIVE_WORKSPACE: {
      return {
        ...state,
        activeWorkSpace: action.payload,
      };
    }

    case ELIMINAR_TDOC: {
      if (!state.listTDoc || !action.payload?._id) {
        return state;
      }

      return {
        ...state,
        listTDoc: state.listTDoc.filter(
          tDoc => tDoc._id !== action.payload._id
        ),
      };
    }

    default:
      return state;
  }
};

export default controlReducer;